const React = require('react');
const upperFirst = require("mn-utils/upperFirst");

const {pushLocation} = require('../../../../../../router');
const {LINK_WITHDRAW_DETAILS} = require('../../../../../../constants/links');

const Tooltip = require('../../../../../dumb/Tooltip/B');
const MenuForItem = require('../../../../../dumb/Menu/ForItem');
const {MerchantTimeCell} = require('../../../../../dumb/TableTimeCell');
const {DisplayStatusWithdraw} = require('../../../../../dumb/StatusDisplay');
const {DisplayAmountMerchant, DisplayHashMerchant, DisplayDateTimeMerchant} = require('../../../../../dumb/DisplayData');

const {ICONS_MAP, DEFAULT_ICON} = require('../constants/icons');
const formatNumCoin = require("../../../../../../utils/formatNumCoin");

module.exports = (props) => {
  const {
    data,
  } = props;
  const {
    id,
    amount,
  } = data;
  const ccCode = data.asset_code;
  const status = data.lifeflow;
  const time = data.created_at || '';
  const fileId = data.file_id || false;

  return (
    <div
      className={`w h layoutRow fhaS fvaC rlv lh fw7 f12 c2 tc lts0em
            ph20 (ph10|w1/4)>1 bgF6F6F6.even`
        + (props.index % 2 === 1 ? ' even' : '')}
      aria-rowindex={props.index}
    >
      <div
        className="pl25@d2"
        aria-colindex="0"
      >
        <div className="layoutRow fvaC fhaS tl">
          {ICONS_MAP[status] || DEFAULT_ICON}
          <div className="pl17 fx1 wmin0">
            {status === 'sent'
              ? (<span className="fw4">{upperFirst(status)}</span>)
              : upperFirst(status)
            }
          </div>
        </div>
      </div>
      <div
        aria-colindex="1"
      >
        <DisplayAmountMerchant
          amount={amount}
          symbol={ccCode}
          type="fiat"
        />
      </div>
      <div
        aria-colindex="2"
      >
        <DisplayHashMerchant>
          {data.transaction_hash}
        </DisplayHashMerchant>
      </div>
      <div
        aria-colindex="3"
      >
        <DisplayDateTimeMerchant
          date={time}
        />
        <MenuForItem items={[
          {
            name: 'Details',
            onClick() {
              pushLocation({
                path: `${LINK_WITHDRAW_DETAILS}/${id}`,
              });
            },
          },
          fileId && (
            {
              name: `Download PDF`,
              onClick() {
                window.open('/f2c/v1/console/file/' + fileId, '_blank').focus();
              }
            }
          )
        ].filter((el) => !!el)}
        />
      </div>
    </div>
  );
};
